import { useEffect } from 'react';
import { preloadRedirects } from '@/hooks/useRedirectMiddleware';

// Common article paths that are likely to be accessed
const COMMON_ARTICLE_PATHS = [
  '/article/elf-warning-letters-guide-templates-examples',
  '/article/holiday-elf-working-parents-time-saving-tips',
  '/article/holiday-elf-teens-creative-ideas',
  '/article/christkind-tradition-modernized-elf-letter-bot',
  '/article/best-holiday-elf-response-letters-2025',
  '/article/holiday-elf-name-generator',
  '/article/creative-holiday-elf-arrival-ideas-2024',
  '/article/holiday-elf-goodbye-letters-templates-ideas',
  '/article/holiday-elf-letter-templates-personalized-magic',
  '/article/holiday-elf-scene-ideas-creative-setups',
  '/article/elf-on-shelf-ideas-easy-quick',
  '/article/elf-on-shelf-ideas-toddlers',
  '/article/elf-letter-templates-christmas-magic',
  '/article/elf-response-letters-kids-questions',
  '/article/christmas-elf-stories-kids'
];

export const RedirectPreloader: React.FC = () => {
  useEffect(() => {
    // Preload common redirects after a short delay to not block initial page load
    const timer = setTimeout(() => {
      preloadRedirects(COMMON_ARTICLE_PATHS);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  // This component doesn't render anything
  return null;
}; 